<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="700px">
    <v-card v-if="reportData" style="min-width:400px">
      <v-card-title class="subtitle-1">For your internal communication only</v-card-title>
      <v-card-text>
        <!-- <a
          class="title"
          :href="'https://www.instagram.com/' + reportData.instagramHandle"
          target="_blank"
        >@{{reportData.instagramHandle}}</a> -->
        <a :href="'https://www.tiktok.com/@' + reportData.instagram" target="_blank" v-if="reportData.isTikTok && reportData.isTikTok === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{reportData.instagram}}</a>
        <a :href="'https://www.instagram.com/' + reportData.instagram" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ reportData.instagram }}</a>
        <v-row class="mt-2">
          <v-col cols="12">
            <v-textarea
              outlined
              name="notes"
              label=""
              hide-details
              v-model="reportData.note"
              value
              @input="$v.reportData.note.$touch()"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="reportData.internalNotes.length > 0">
          <v-col class="mt-0 pt-0" cols="12" md="12" sm="12" lg="12">
            <v-card flat max-height="300px" class="overflow-hidden overflow-y-auto">
              <v-card-text class="mt-0 pt-0" v-if="reportData.internalNotes.length > 0">
                <element v-for="(msg, index) in reportData.internalNotes" :key="index">
                  <v-row>
                    <v-col>
                      <p class="body-2 font-weight-bold">{{msg.author ? msg.author.name : '-'}}</p>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn 
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete Note"
                        @click="deleteNote(fileIndex)"
                        color="error"
                        small
                        v-if="showAction(msg)">
                          <v-icon color="white" small>delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <p class="body-1 font-weight-medium">{{msg.notes}}</p>
                  <p class="caption text-xs-right font-italic">{{formatTime(msg.timestamp)}}</p>
                  <v-divider></v-divider>
                </element>
              </v-card-text>
              <v-card-text v-else>
                <p class="body-1 fong-weight-bold">
                  No Internal Notes
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="green darken-1" text @click="saveNote()">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
// import utils from '../../../../utils'
import campaignAPIs from '../Campaign/campaignAPIs';
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import reverse from 'lodash/reverse';
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';
// import config from '../config';
export default {
  components: { Loading },
  data() {
    return {
      reportData: null,
      isLoading: false
    };
  },
  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value(value) {
      if (value) {
        this.reportData = Object.assign({}, this.data);
        this.clearForm()
      }
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserID: function () {
      return this.$store.state.user.id;
    }
  },
  validations: {
    reportData: {
      note: {
        required
      }
    }
  },
  methods: {
    saveNote() {
      if (this.reportData !== null) {
        let formData = new FormData();
        formData.append('reportID', this.reportData.id);
        formData.append('note', this.reportData.note);
        this.isLoading = true
        campaignAPIs
          .saveReportNote(formData)
          .then((response) => {
            this.isLoading = false
            this.reportData.internalNotes = response.internalNotes
            this.beautifyData()
            this.$swal({
              position: 'top-center',
              title: 'Successfully Saved Notes!',
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            this.$emit('savedNotes')
            this.$emit('input');
          })
          .catch(error => {
            this.isLoading = false
            this.$swal({
              position: 'top-center',
              title: 'Error while saving note',
              type: 'error',
              timer: 1500
            });
            console.log(error);
          });
      }
    },
    deleteNote(fileIndex) {
      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete note?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          let updateNote = Object.assign([], this.reportData.internalNotes)
          updateNote.splice(fileIndex, 1)
          let formData = new FormData();
          formData.append('reportID', this.reportData.id);
          formData.append('internalNotes', JSON.stringify(updateNote));
          this.isLoading = true;
          campaignAPIs.saveReportNote(formData)
            .then(response => {
              this.reportData.internalNotes = updateNote
              this.isLoading = false;
              // Dismiss modal by triggering the click event on Close button
              this.$swal({
                text: 'Note Deleted',
                type: 'success'
              });
              this.$emit('savedNotes')
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)
              this.isLoading = false;
            })
        }
      })
    },
    beautifyData() {
      if (this.reportData.internalNotes !== undefined) {
        this.reportData.internalNotes = reverse(this.reportData.internalNotes)
      }
    },
    showAction(item) {
      if (item.author !== undefined) {
        if (item.author.id === this.currentUserID) {
          return true
        }
      }
      return false
    },
    clearForm() {
      this.reportData.note = ''
    },
    formatTime(value) {
      return moment(value).fromNow();
    }
  }
};
</script>



// WEBPACK FOOTER //
// reportNotesModal.vue?07e7a13c